import { styled } from "@shoothill/core";
import { theme } from "../../Globals/Styles/AppTheme";

export const AddContactTitle = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: row;
    color: ${theme.palette.orange.main};
    font-size: 18px;
    padding: 15px 30px;

    img {
        padding-right: 15px;
    }

    @media screen and (max-width: 1024px) {
    }

    @media screen and (max-width: 640px) {
        flex-direction: row;
    }
`;

export const SupplierCell = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: row;
    padding: 0 30px;

    // background-color: orange
    @media screen and (max-width: 1024px) {
    }

    @media screen and (max-width: 640px) {
        flex-direction: row;
    }
`;

export const AddEditSupplierViewRow = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: row;
    width: 100%;
    padding: 8px 0;
    align-items: flex-start;

    // background-color: orange
    @media screen and (max-width: 1024px) {
    }

    @media screen and (max-width: 640px) {
        flex-direction: row;
    }
`;
